module.exports = __webpack_public_path__ + "img/nav-design-hammered.026367d.webp";